import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { useTheme } from "../../../../hooks/theme";
import CartaoGrafico, { CORES } from "./CartaoGrafico";
import useResumoDespacho from "./useResumoDespacho";

// Etiquetas emitidas × com falha por transportadora (PO1-3494): barras lado a
// lado, uma linha por transportadora/serviço do resumo (`porTransportadora`).

const rotulo = (t) => (t.servico ? `${t.nome} · ${t.servico}` : t.nome || "-");

export default function ChartEtiquetasPorTransp({ deferLoad = false, onRegisterFetch }) {
  const { darkMode } = useTheme();
  const { dados, carregando, erro } = useResumoDespacho({ deferLoad, onRegisterFetch });
  const cor = darkMode ? "#e9ecef" : "#1e1e2f";
  const linhas = dados ? dados.porTransportadora.map((t) => ({ ...t, rotulo: rotulo(t) })) : [];

  return (
    <CartaoGrafico titulo="Etiquetas por transportadora" subtitulo="Emitidas e com falha, por transportadora e serviço, no período" carregando={carregando} erro={erro} vazio={!linhas.length}>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={linhas} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
          <CartesianGrid stroke="rgba(45,206,137, 0.1)" strokeWidth={1} />
          <XAxis dataKey="rotulo" stroke={cor} style={{ fontWeight: 100 }} />
          <YAxis stroke={cor} style={{ fontWeight: 100 }} allowDecimals={false} />
          <Tooltip contentStyle={{ background: darkMode ? "#1e1e2f" : "#fff", border: "none" }} />
          <Legend layout="horizontal" verticalAlign="bottom" align="center" />
          <Bar name="Emitidas" dataKey="emitidas" fill={CORES.emitidas} />
          <Bar name="Com falha" dataKey="falhas" fill={CORES.falhas} />
        </BarChart>
      </ResponsiveContainer>
    </CartaoGrafico>
  );
}
